import React from 'react';
import {
  Card,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const MODEL_NAME = 'pastOrdersTile';

/**
 * Tile component for adding materials from past orders
 */
export const PastOrdersTile = () => {

  const handleClick = () => {
    // 10.1 AI Entry Points - Track copy from past orders entry point click
    triggerAnalytics(TRACK.LIST_BUILDER_ENTRY_POINT_CLICK, {
      entryPoint: 'copy from past orders'
    });
    // Future implementation for past orders functionality
  };

  return (
    <div onClick={handleClick} role="presentation" className="sui-h-full">
      <Card
        orientation="vertical"
        PaperProps={{ className: 'sui-h-full' }}
        tabIndex={0}
        role="button"
        aria-label="Copy materials from past orders"
      >
        <CardBody>
          <Typography variant="h6" weight="bold">
            Copy from past orders
          </Typography>

          <div className="sui-mt-1">
            <Typography variant="body-small" color="subtle">
              Add items from your purchase history
            </Typography>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default PastOrdersTile;
